import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SCANNED_IMAGE = 'GET_SCANNED_IMAGE';
export const GET_SCANNED_IMAGE_SUCCESS = 'GET_SCANNED_IMAGE_SUCCESS';
export const GET_SCANNED_IMAGE_FAILURE = 'GET_SCANNED_IMAGE_FAILURE';

// Action Creators
export const getScannedImage = () => ({
  type: GET_SCANNED_IMAGE,
});

export const getScannedImageSuccess = (users) => ({
  type: GET_SCANNED_IMAGE_SUCCESS,
  payload: users,
});

export const getScannedImageFailure = (error) => ({
  type: GET_SCANNED_IMAGE_FAILURE,
  payload: error,
});

// Thunk Function
export const getScannedImageCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getScannedImage());
    try {
      const response = await getMethodWithToken(url.scannedImage + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getScannedImageSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getScannedImageFailure(error?.message));
    }
  };
};
